import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3dexc9gstg: FaireBrandEntity = {
  token: "b_3dexc9gstg",
  type: "brand",
  name: "Thuli",
  avatarUrl:
    "https://cdn.faire.com/fastly/89645dfae3597e544deccd2c600f9d7f44e791110c28968b7e5a8acb03071417.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8fa8dc9e769a6ec645a9c2a61092f7976709821ddd0a104bc0d5e6328375241b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/89645dfae3597e544deccd2c600f9d7f44e791110c28968b7e5a8acb03071417.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8fa8dc9e769a6ec645a9c2a61092f7976709821ddd0a104bc0d5e6328375241b.png",
  location: "Westwood, NJ, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Thuli was born from a deep reverence for craft, culture, and a desire to reimagine the way fashion is made and worn. Each garment carries a story — of the artisan who shaped it, the tradition it honors, and the conscious choice to embrace a slower, more thoughtful approach to dressing.\n\nRooted in New Jersey and connected to craft communities around the world, Thuli collaborates with skilled artisans to create pieces that seamlessly blend heritage techniques with modern design. Our collections are an invitation to wear clothing that reflects values — beauty, sustainability, and meaning in every thread.\n\nEvery piece is handmade with care, passion, and a deep respect for both people and the planet.\n\nGlobal Reach, Seamless Delivery:\n\nAll Thuli pieces are shipped directly from our New Jersey studio, guaranteeing a seamless process with no tariffs or customs. This ensures hassle-free deliveries for our clients, no matter where they are.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:38.281Z",
    importedBy: "entity-db-cli",
  },
};
